import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IconComponent } from "../icon/icon.component";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'branding-block',
    template: `
<div class="title">{{ title }}</div>
<div class="selected" *ngIf="greyText || changeText">
  <div class="greyText" *ngIf="!hideGreyText">{{ greyText | uppercase }}</div>
  <icon *ngIf="icon" [icon]="icon" (click)="change.emit()"></icon>
  <div class="changeText" (click)="change.emit()">{{ changeText }}</div>
</div>
<ng-content></ng-content>
`,
    styles: [`
  :host { position: relative; padding: 20px; border: 1px solid var(--contentbgoutline); border-radius: 6px; display: flex; flex-direction: column; }
  .selected { display: flex; width: 100%; justify-content: center; white-space: nowrap; flex-wrap: wrap; align-items: center; }
  .title { position: absolute; top: 5px; left: 12px; font-weight: bold; font-size: 12px; }
  .greyText { color: var(--light-text); font-size: 11px; margin-right: 10px; }
  .changeText { cursor: pointer; color: var(--primary); font-weight: bold; font-size: 11px;  }
  icon { cursor: pointer; color: var(--primary); margin-right: 5px; margin-left: -5px; }
  .changeText:hover { color: var(--primaryhover); }
`],
    standalone: true,
    imports: [IconComponent, CommonModule],
})
export class BrandingBlockWrapperComponent {
  @Input() title: string
  @Input() hideGreyText: boolean
  @Input() icon: string
  @Input() greyText: string = 'NONE SELECTED'
  @Input() changeText: string = '+ ADD FROM BRAND OPTIONS'
  @Output() change: EventEmitter<void> = new EventEmitter()
}

